export const classifyList = [
  {
    value: '爱情，朋友',
    label: '爱情，朋友',
    youzhi: '2',
    children: [
      { value: '邂逅一场爱情', label: '邂逅一场爱情' },
      { value: '有趣的邂逅', label: '有趣的邂逅' },
      { value: '开始一起生活', label: '开始一起生活' },
      { value: '约会', label: '约会' },
      { value: '催婚姻', label: '催婚姻' },
      { value: '婚配（建议订制）', label: '婚配（建议订制）' },
      { value: '订婚', label: '订婚' },
      { value: '领结婚证', label: '领结婚证' },
      { value: '嫁娶（建议订制）', label: '嫁娶（建议订制）' },
      { value: '催桃花', label: '催桃花' },
      { value: '欲爱', label: '欲爱' },
      { value: '催丁', label: '催丁' },
      { value: '送一个小礼物', label: '送一个小礼物' },
      { value: '送一个大礼物', label: '送一个大礼物' },
      { value: '和解矛盾', label: '和解矛盾' },
      { value: '买宠物', label: '买宠物' },
      { value: '会朋友', label: '会朋友' },
      { value: '结盟（义结金兰）', label: '结盟（义结金兰）' },
      { value: '请客，聚餐，朋友聚会', label: '请客，聚餐，朋友聚会' }
    ]
  },
  {
    value: '美护',
    label: '美护',
    youzhi: '2',
    children: [
      { value: '美容护理治疗，包括按摩、SPA等', label: '美容护理治疗，包括按摩、SPA等' },
      { value: '理发', label: '理发' },
      { value: '染发', label: '染发' },
      { value: '烫发', label: '烫发' },
      { value: '想头发慢长理发', label: '想头发慢长理发' },
      { value: '想头发快长理发', label: '想头发快长理发' },
      { value: '脱毛', label: '脱毛' },
      { value: '修剪手、脚指甲', label: '修剪手、脚指甲' },
      { value: '新生婴儿首次理发', label: '新生婴儿首次理发' },
      { value: '新娘挽面', label: '新娘挽面' },
      { value: '僧尼剃度', label: '僧尼剃度' }
    ]
  },
  {
    value: '旅行',
    label: '旅行',
    youzhi: '2',
    children: [
      { value: '乘机休闲旅行', label: '乘机休闲旅行' },
      { value: '乘机出差', label: '乘机出差' },
      { value: '开车休闲旅行', label: '开车休闲旅行' },
      { value: '开车商务旅行', label: '开车商务旅行' },
      { value: '秘密旅行', label: '秘密旅行' },
      { value: '一般性旅游', label: '一般性旅游' }
    ]
  },
  {
    value: '金钱与财务',
    label: '金钱与财务',
    youzhi: '2',
    children: [
      { value: '商人置货', label: '商人置货' },
      { value: '购买贵重物品（珠宝、古董）', label: '购买贵重物品（珠宝、古董）' },
      { value: '购买股票、债券', label: '购买股票、债券' },
      { value: '出售股票、债券', label: '出售股票、债券' },
      { value: '提出保险索赔', label: '提出保险索赔' },
      { value: '缴纳税申报', label: '缴纳税申报' },
      { value: '贷款', label: '贷款' },
      { value: '借钱', label: '借钱' },
      { value: '放款', label: '放款' },
      { value: '催财', label: '催财' },
      { value: '收回欠款', label: '收回欠款' },
      { value: '讨债', label: '讨债' }
    ]
  },
  {
    value: '健康',
    label: '健康',
    youzhi: '2',
    children: [
      { value: '开始节食', label: '开始节食' },
      { value: '牙科治疗', label: '牙科治疗' },
      { value: '开始停止治疗', label: '开始停止治疗' },
      { value: '体检', label: '体检' },
      { value: '医院治疗检查', label: '医院治疗检查' },
      { value: '做手术（非紧急，计划中的）', label: '做手术（非紧急，计划中的）' },
      { value: '髋关节手术', label: '髋关节手术' },
      { value: '膝关节手术', label: '膝关节手术' },
      { value: '整容手术（面部）', label: '整容手术（面部）' },
      { value: '形体手术（乳房部位）', label: '形体手术（乳房部位）' },
      { value: '医院看病，一般性疾病', label: '医院看病，一般性疾病' },
      { value: '医院看病，精神性疾病', label: '医院看病，精神性疾病' },
      { value: '安床（睡眠）', label: '安床（睡眠）' }
    ]
  },
  {
    value: '园艺',
    label: '园艺',
    youzhi: '2',
    children: [
      { value: '耕地或施肥', label: '耕地或施肥' },
      { value: '播种：菜、花、草', label: '播种：菜、花、草' },
      { value: '种植地下蔬菜（土豆、胡萝卜等）', label: '种植地下蔬菜（土豆、胡萝卜等）' },
      { value: '种植嫁接树木', label: '种植嫁接树木' },
      { value: '砍伐或锯断树木', label: '砍伐或锯断树木' },
      { value: '修剪藤蔓', label: '修剪藤蔓' },
      { value: '收割，收获', label: '收割，收获' }
    ]
  },
  {
    value: '不动产，阳阴宅',
    label: '不动产，阳阴宅',
    youzhi: '2',
    children: [
      { value: '买房子', label: '买房子' },
      { value: '卖房子', label: '卖房子' },
      { value: '购买土地（建议订制）', label: '购买土地（建议订制）' },
      { value: '卖出土地', label: '卖出土地' },
      { value: '买车', label: '买车' },
      { value: '卖车', label: '卖车' },
      { value: '阳宅布局', label: '阳宅布局' },
      { value: '动土（阳宅）', label: '动土（阳宅）' },
      { value: '行砖', label: '行砖' },
      { value: '安门', label: '安门' },
      { value: '封顶', label: '封顶' },
      { value: '做灶', label: '做灶' },
      { value: '拆灶', label: '拆灶' },
      { value: '围墙大门', label: '围墙大门' },
      { value: '搬新家：进宅，入伙，移徙', label: '搬新家：进宅，入伙，移徙' },
      { value: '建造工作场所：工厂、车间、工作室', label: '建造工作场所：工厂、车间、工作室' },
      { value: '建造', label: '建造' },
      { value: '修造', label: '修造' },
      { value: '安装机械的开车试车', label: '安装机械的开车试车' },
      { value: '破土（阴宅）', label: '破土（阴宅）' },
      { value: '捡骨', label: '捡骨' },
      { value: '迁葬', label: '迁葬' },
      { value: '立碑', label: '立碑' },
      { value: '安葬', label: '安葬' }
    ]
  },
  {
    value: '事业',
    label: '事业',
    youzhi: '2',
    children: [
      { value: '外出工作', label: '外出工作' },
      { value: '雇佣助理或新员工', label: '雇佣助理或新员工' },
      { value: '参加工作面试', label: '参加工作面试' },
      { value: '演员歌手音乐家舞蹈家试镜或竞选', label: '演员歌手音乐家舞蹈家试镜或竞选' },
      { value: '签订合同、协议', label: '签订合同、协议' },
      { value: '承诺合作关系', label: '承诺合作关系' },
      { value: '创业、开业、开市（建议订制）', label: '创业、开业、开市（建议订制）' },
      { value: '上任（赴任）接受新职位', label: '上任（赴任）接受新职位' },
      { value: '谒贵（拜访贵人）', label: '谒贵（拜访贵人）' },
      { value: '公关，沟通，交流', label: '公关，沟通，交流' },
      { value: '贸易', label: '贸易' },
      { value: '法律', label: '法律' },
      { value: '催贵', label: '催贵' },
      { value: '国外事务', label: '国外事务' },
      { value: '管理', label: '管理' },
      { value: '一般性选举', label: '一般性选举' },
      { value: '幕后工作（幕僚或偏支持类）', label: '幕后工作（幕僚或偏支持类）' },
      { value: '提起诉讼', label: '提起诉讼' }
    ]
  },
  {
    value: '学习',
    label: '学习',
    youzhi: '2',
    children: [
      { value: '安书桌，办公桌', label: '安书桌，办公桌' },
      { value: '学习班，复习班，例如：报考研班', label: '学习班，复习班，例如：报考研班' },
      { value: '布置书房', label: '布置书房' },
      { value: '布置文昌位', label: '布置文昌位' },
      { value: '接受学习、培训', label: '接受学习、培训' }
    ]
  },
  {
    value: '公共，文宣，广告',
    label: '公共，文宣，广告',
    youzhi: '2',
    children: [
      { value: '公共政治宣传', label: '公共政治宣传' },
      { value: '政治选举（必须订制）', label: '政治选举（必须订制）' },
      { value: '大型演出、集会', label: '大型演出、集会' },
      { value: '商业广告投放（建议订制）', label: '商业广告投放（建议订制）' },
      { value: '公益广告投放（建议订制）', label: '公益广告投放（建议订制）' },
      { value: '新建政府机关开放（必须定制）', label: '新建政府机关开放（必须定制）' },
      { value: '新建学校开放（建议订制）', label: '新建学校开放（建议订制）' },
      { value: '桥梁开放', label: '桥梁开放' },
      { value: '公园开放', label: '公园开放' },
      { value: '城市广场开放', label: '城市广场开放' },
      { value: '城市休闲区域建开放', label: '城市休闲区域建开放' },
      { value: '市民健身区域开放', label: '市民健身区域开放' }
    ]
  },
  {
    value: '宗教，信仰',
    label: '宗教，信仰',
    youzhi: '2',
    children: [
      { value: '祭祖', label: '祭祖' },
      { value: '拜神：求神降幅，酬神，还愿，谢神', label: '拜神：求神降幅，酬神，还愿，谢神' },
      { value: '安香：请神，安神位，安祖先牌位', label: '安香：请神，安神位，安祖先牌位' },
      { value: '进祠堂升座', label: '进祠堂升座' },
      { value: '神佛塑像安座', label: '神佛塑像安座' },
      { value: '开光点睛', label: '开光点睛' },
      { value: '法会：建教，庙宇里面的大型活动等。（必须订制）', label: '法会：建教，庙宇里面的大型活动等。（必须订制）' },
      { value: '斋戒沐浴', label: '斋戒沐浴' }
    ]
  }
]
